export default [
  {
    path: '/myCouponList',
    meta: { title: '我的优惠券' },
    component: () =>
      import(
        /* webpackChunkName: "myCouponList" */ '@/pages/coupons/mycoupon.vue'
      )
  },
  {
    path: '/myVerifyCouponList',
    meta: { title: '票券核销' },
    component: () =>
      import(
        /* webpackChunkName: "myVerifyCouponList" */ '@/pages/coupons/myverifylistnew.vue'
      )
  },
  {
    path: '/pushcoupons',
    meta: { title: '推送优惠券' },
    component: () =>
      import(
        /* webpackChunkName: "pushcoupons" */ '@/pages/coupons/pushcoupons.vue'
      )
  },

  {
    path: '/pushcouponsDetail',
    meta: { title: '推送优惠券详情' },
    component: () =>
      import(
        /* webpackChunkName: "pushcouponsDetail" */ '@/pages/coupons/pushcouponsDetail.vue'
      )
  },
  {
    path: '/verificationCoupon',
    meta: { title: '核销优惠券兑换' },
    component: () =>
      import(
        /* webpackChunkName: "verificationCoupon" */ '@/pages/coupons/verificationCoupon.vue'
      )
  },
  {
    path: '/verfitateDetail',
    meta: { title: '核销优惠券详情' },
    component: () =>
      import(
        /* webpackChunkName: "verfitateDetail" */ '@/pages/coupons/verfitateDetail.vue'
      )
  },
  {
    path: '/verifyCouponSharePage',
    meta: { title: '核销优惠券分享界面' },
    component: () =>
      import(
        /* webpackChunkName: "verifyCouponSharePage" */ '@/pages/coupons/verifyCouponSharePage.vue'
      )
  },

  {
    path: '/createVerifiedCoupon',
    meta: { title: '创建核销优惠券界面' },
    component: () =>
      import(
        /* webpackChunkName: "createVerifiedCoupon" */ '@/pages/coupons/createVerifiedCoupon.vue'
      )
  },

  {
    path: '/productCouponSharePage',
    meta: { title: '通用商品优惠券分享页面' },
    component: () =>
      import(
        /* webpackChunkName: "productCouponSharePage" */ '@/pages/coupons/productCouponSharePage.vue'
      )
  },
  {
    path: '/watchCouponSharePage',
    meta: { title: '观看优惠券分享页面' },
    component: () =>
      import(
        /* webpackChunkName: "watchCouponSharePage" */ '@/pages/coupons/watchCouponSharePage.vue'
      )
  },
  // 观看优惠券分享页面非全场券领取详情
  {
    name: 'couponDetails',
    path: '/couponDetails',
    meta: { title: '优惠券领取详情' },
    component: () =>
      import(
        /* webpackChunkName: "couponDetails" */ '@/pages/coupons/couponDetails.vue'
      )
  }
]
